export const startReceiptMission = (id) => ({
  type: "START_RECEIPT_MISSION",
  id
});



// WEBPACK FOOTER //
// ./src/store/actions/help/receipts.js